export class LockedList {
    public employeeName: string;
    public employeeId: string;
    public days: any;
    public reason: string;
    public reportingManger: string;
    public fromDate: any;
    public requestedFlag: boolean;

    constructor(data: any, type:string) {
        this.employeeName = data.Empname ? data.Empname : '';
        this.employeeId = data.Empno ? data.Empno : '';        
        this.reason = data.lockedDetails.reason;
        this.reportingManger = data.RMname;
        this.fromDate = new Date(data.lockedDetails.lockedDate).toLocaleDateString();
        this.requestedFlag = data.unlockRequest.Requested ? data.unlockRequest.Requested : false;
        if (type === 'nonAdherence') {
            this.days = this.getDiffDays(data.lockedDetails.lockedDate);
        } 
        if (type === 'nonCompliance') {
            this.days = this.getDiffDays(data.lockedDetails.dateOfNonCompliance);
        }
    }

    getDiffDays(date) {
        const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        const firstDate = new Date(date);
        const secondDate = new Date();

        const diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
        return diffDays;
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/non-compliance-list/non-compliance-list.ts